/**
 * IBAN-, BIC- und BLZ-Prüfung im Formular.
 *
 * **Bequemlichkeitskopie, nicht maßgeblich.** Maßgeblich prüft und normalisiert das Backend in
 * `backend/Infrastructure/SepaValidation.cs` — aufgerufen beim Anlegen und Ändern einer Person
 * (`PersonsController.Create/Update/BankDetails`), im Vertragswidget
 * (`ContractWidgetController.Sepa`), im App-Profil (`AppController.Profile`) und beim
 * Lastschriftlauf (`SepaDirectDebitRunsController`, `SepaDirectDebitRunBookingService`). Persistiert
 * wird ausschließlich die dort normalisierte Form.
 *
 * Diese Fassung existiert nur, damit ein Tippfehler schon im Formular auffällt statt erst nach dem
 * Absenden. `sepa.test.ts` hält beide Fassungen gegen dieselben Fälle.
 */
export { normalizeBankCode as normalizeIban, normalizeBankCode as normalizeBic, validBankIban as isValidIban, validBankBic as isValidBic } from "../../../../../../shared/frontend/banking/accounts/bankAccountValidation";

/** Entfernt alle Leerzeichen und Nicht-Ziffern aus der Bankleitzahl (BLZ). */
export function normalizeBlz(input: string): string {
  return String(input || "").replace(/\D/g, "");
}

/**
 * Vorbelegung für den Kontoinhaber aus dem Personennamen.
 *
 * Bequemlichkeitskopie, nicht maßgeblich. Beim Anlegen einer Person setzt
 * `PersonsController.Create` denselben Wert, wenn kein Kontoinhaber mitgegeben wird.
 * Im Formular steht der Name schon sichtbar, damit er überschrieben werden kann.
 */
export function defaultBankAccountHolder(firstName?: string | null, lastName?: string | null): string {
  return `${String(firstName || "").trim()} ${String(lastName || "").trim()}`.trim();
}
